export default __webpack_public_path__ + "static/media/kitchen5-afterD-1024w.bbcd5c29.avif";